<finxone-web-frontend-copy-share
  [textContentTemplate]="textContentTemplate"
  [contentStyle]="contentStyle"
  [globalStylingClass]="globalStylingClass"
  [isAllowedGlobalStyling]="isAllowedGlobalStyling"
  [copyContentTemplate]="copyContentTemplate"
  (copyContentValue)="copyContent($event)"
></finxone-web-frontend-copy-share>
